const HEADING_SELECTORS = ['h1', 'h2', 'h3', 'h4'];
const TRACK_SELECT_CLASS = '.js-track-select-item';

/**
 * Finds the closest heading element that precedes the given element in the DOM tree.
 * Traverses up and backwards through the DOM to locate a heading (h1-h4) that is not
 * inside a `.js-track-select-item` element.
 *
 * @param element - The starting element to search from
 * @return A formatted string with the heading text or document title, suffixed with ", items"
 */
export function findListItemClosestHeading(element: HTMLElement): string {
	let currentNode: HTMLElement | null = element;

	// Traverse the DOM tree backwards to find the closest preceding heading
	while (currentNode?.parentNode) {
		// Move to previous sibling or parent
		currentNode =
			(currentNode.previousElementSibling as HTMLElement | null) ??
			(currentNode.parentNode as HTMLElement | null);

		if (!currentNode) {
			break;
		}

		const tagName = currentNode.tagName?.toLowerCase();

		// Stop at body or html level
		if (tagName === 'body' || tagName === 'html') {
			currentNode = null;
			break;
		}

		// Check if current node is a valid heading
		const isHeading = HEADING_SELECTORS.some((selector) => currentNode?.matches(selector));
		const isOutsideTrackSelect = !currentNode?.closest(TRACK_SELECT_CLASS);

		if (isHeading && isOutsideTrackSelect) {
			break;
		}
	}

	// Use heading text if found, otherwise fall back to document title
	const headingText = currentNode?.textContent ?? document.title;

	// Clean and format the heading text
	return headingText.replace(/[\t\n]/g, ' ').trim();
}
